import type { ReactNode } from 'react';

export const symbol_hourglass_disabled: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M812-62.91 794-80H190q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h58v-127q0-70 40.5-128.5T394-480q-41-17-76.5-51T264-610L47-827q-9-9.07-9-21.53Q38-861 47.05-870q9.06-9 21.5-9Q81-879 90-870l765 765q9 9 9 21t-9.05 21q-9.06 9-21.5 9Q821-54 812-62.91ZM652-820H238q-15 0-22.5-9.32t-7.5-20.5q0-11.18 7.5-20.68T238-880h532q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5h-58v126q0 64-33.5 118.5T589-491q-10 5-19.5-.5T555-508q-5-11-2-22t13-17q38-23 62-62t24-85v-126ZM308-140h344v-82L441-433q-57 14-95 60.5T308-267v127Zm404 0h22l-22-22v22Z"
		/>
	</svg>
);
